/**
 * A task is force-assigned when its required resource has a non-blank id.
 */
export const isForcedAssignment = (
  requiredResourceId?: string | null
): boolean =>
  typeof requiredResourceId === 'string' && requiredResourceId !== '';
